module.exports = __webpack_public_path__ + "static/media/surgiscope-container-img.37538864.png";